export function formatNumber(value) {
    return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') || ''
  }
  
  export function formatRupiah(value) {
    return 'Rp' + formatNumber(value || 0)
  }